import { Grid } from "@mui/material";
import Product from "features/clients/Purchase/Sets/Product/Product";
import React, { useContext, useEffect } from "react";
import { transformDataForTrayModal } from "utils/transformdata";
import { useGetSetsDesign } from "../Api/api";

import apiClient from "lib/api-client";
import { useGlobalContext } from "context/GlobalContext";
import InfoModal from "components/ui/InfoModal/InfoModal";
import SortContext from "context/SortContext";
import { useLocation, useParams } from "react-router-dom";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";

function SetPurchaseDesignPage({ setName, isPartial }) {

  const { search } = useLocation();
  const { clientId } = useParams();
  const setId = new URLSearchParams(search).get("setId");

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status,
    isLoading
  } = useGetSetsDesign({
    setId,
    clientCode: clientId,
    sortBy: "Design Date",
    sortOrder: "asc",
    searchTerm: "",
    limit: 20,
  });

  const designs = data?.pages?.[0]?.set?.designs || [];

  const { setSortOptions } = useContext(SortContext);
  const {
    infoModalOpen,
    setInfoModalOpen,
    setSetDesings,
    setDisplayCount,
    setSearchResultCount,
    setIsInfoBtn,
    setFilterChangeCount,
    setFilterChangeDesignCount,
    setSearchSuffix,
    dynamicfilterCount,
    filterChangeCount,
    filterChangeDesignCount,
  } = useGlobalContext();

  const fetchData = () => apiClient.get(`/api/v1/set/getSetWeightInfo/${setId}`);

  useEffect(() => {
    setIsInfoBtn(true);
    setSortOptions(["d", "e", "f"]);
    return () => {
      setIsInfoBtn(false);
      setSortOptions([]);
    };
  }, []);

  useEffect(() => {
    if (dynamicfilterCount) {
      setFilterChangeCount(designs?.length);
      // setFilterChangeDesignCount(data?.designs?.length);
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
      // setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    setSearchSuffix("");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [data]);

  
  
  if (isLoading) return <ProductSkeleton count={12} />;

  return (
    <>
      <Grid
        container
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        sx={{
          flex: "1 1 1",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "32px",
          rowGap: "32px",
          maxHeight: "85vh",
          overflow: "auto",
          scrollbarWidth: "none",
        }}
      >
        {designs &&
          designs?.map((design) => {
            const transformedProduct = transformDataForTrayModal(design);
            return <Product data={transformedProduct} allData={data?.designs} />;
          })}
      </Grid>
      <InfoModal open={infoModalOpen} setOpen={setInfoModalOpen} setDetails={true} fetchData={fetchData} title="Metadata Details" />
    </>
  );
}

export default SetPurchaseDesignPage;
